import { useEffect, useState } from "react";
import resolveFirebaseErrorMessage from "../utils/resolveFirebaseErrorMessage";

const FirebaseError = ({ error }) => {
  const [errorMessage, setErrorMessage] = useState(
    resolveFirebaseErrorMessage(error)
  );

  useEffect(() => {
    const id = setTimeout(() => {
      setErrorMessage("");
    }, 3000);

    return () => {
      clearTimeout(id);
    };
  }, []);

  return errorMessage ? (
    <span className="block text-center text-red-700 font-black">
      {errorMessage}
    </span>
  ) : (
    <></>
  );
};

export default FirebaseError;
